/**
 * Branding
 */

// Module dependencies
import 'protons';
import 'atoms/image';
import './logo.svg';

// Module template
import './_branding.twig';

export const name = 'branding';

export function disable() {}

export function enable() {}

export default enable;
